import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AppBase } from '../app-base';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.sass']
})
export class ModalPopupComponent extends AppBase {
  @ViewChild('childModal') public childModal: ModalDirective;
  public modalRef: BsModalRef;

  public popupSettings: {
    doNotDisturb: number,
    popupID: number,
    dismissText: string,
    ctaText: string,
    ctaLink: string,
    ctaTarget: string,
    moreInfoText: string,
    moreInfoLink: string,
    moreInfoTarget: string,
    imageContent: string,
    customStyles: string,
  } = {
    // doNotDisturb -> Number of days to hide popup
    //    0 = session cookie
    //    -1 = always show
    //    365 = don't show for a year
    doNotDisturb: 0,
    popupID: 0,
    dismissText: 'X',
    ctaText: '',
    ctaLink: '#',
    ctaTarget: '_self',
    moreInfoText: '',
    moreInfoLink: '#',
    moreInfoTarget: '_blank',
    imageContent: '',
    customStyles: '',
  };

  constructor(private router: Router) {
    super();
  }

  isAbsoluteURL(url) {
    const r = new RegExp('^(?:[a-z]+:)?//', 'i');
    return r.test(url);
  }

  navigateTo(url, target) {
    window.open(url, target);
  }

  public ctaModal() {
    this.navigateTo(this.popupSettings.ctaLink, this.popupSettings.ctaTarget);
    this.dismissModal();
  }

  public moreInfoModal() {
    this.navigateTo(this.popupSettings.moreInfoLink, this.popupSettings.moreInfoTarget);
    this.dismissModal();
  }

  public dismissModal() {
    if (this.popupSettings.doNotDisturb >= 0) {
      this.setCookie(`popup_${this.popupSettings.popupID}`, '1', this.popupSettings.doNotDisturb);
    }
    this.childModal.hide();
  }

  public shouldOpen() {
    // return !this.getCookie(`popup_${this.popupSettings.popupID}`);
    return true;
  }

  public openModal(settings) {
    this.popupSettings = { ...this.popupSettings, ...settings };
    if (this.shouldOpen()) {
      this.childModal.show();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modal-popup/modal-popup.component.ts